import { createAction } from 'typesafe-actions';
import { IClientState, Token } from './types';

export const INIT_CLIENT = 'client/INIT_CLIENT';
export const CREATE_TEMP_CLIENT = 'client/CREATE_TEMP_CLIENT';
export const GET_CLIENT = 'client/GET_CLIENT';
export const GET_CLIENT_TOKEN = 'client/GET_CLIENT_TOKEN';
export const UPDATE_REDIRECT_PATH = 'client/UPDATE_REDIRECT_PATH';
export const UPDATE_CLIENT = 'client/UPDATE_CLIENT';
export const UPDATE_TOKEN = 'client/UPDATE_TOKEN';
export const LOGOUT = 'client/LOGOUT';

export const logout = createAction(LOGOUT)();

export const initClient = createAction(INIT_CLIENT)();

export const createTempClient = createAction(CREATE_TEMP_CLIENT)<
  Partial<IClientState>
>();
export const getClient = createAction(GET_CLIENT)<Partial<IClientState>>();
export const updateClient = createAction(UPDATE_CLIENT)<
  Partial<IClientState>
>();

export const getClientToken = createAction(GET_CLIENT_TOKEN)<
  Partial<IClientState>
>();
export const updateRedirectPath = createAction(UPDATE_REDIRECT_PATH)<string>();
export const updateToken = createAction(UPDATE_TOKEN)<Token>();
